import React from 'react';
import { ChevronRight } from 'lucide-react';
export function Hero() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-[#0a0a0a] py-12 md:py-20 px-4" data-id="element-84">
      <div className="max-w-6xl mx-auto" data-id="element-85">
        <div className="flex justify-center mb-6" data-id="element-86">
          <span className="inline-block px-6 py-2 bg-[#C6FF3C]/10 border border-[#C6FF3C] rounded-full text-[#C6FF3C] text-sm font-semibold uppercase tracking-wide" data-id="element-87">
            Exclusivo para Amantes del Pádel
          </span>
        </div>

        <h1 className="headline-font text-4xl md:text-6xl lg:text-7xl text-center text-white uppercase leading-tight mb-8" data-id="element-88">
          DOMINÁ EL PÁDEL EN <span className="text-[#C6FF3C]" data-id="element-89">8 SEMANAS</span>{' '}
          CON <span className="text-[#C6FF3C]" data-id="element-90">PÁDEL SMART PRO ELITE</span>
        </h1>

        <div className="flex justify-center mb-8" data-id="element-91">
          <img src="https://cdn.magicpatterns.com/uploads/nwZD7wQNkfvSiQBuu1oc8X/7c1eda8a-fa45-4a31-8042-481caea61529-removebg-preview.png" alt="Padel Smart Pro Elite" className="max-w-full h-auto cursor-pointer hover:scale-105 transition-transform duration-300" style={{
          maxHeight: '500px'
        }} onClick={scrollToCompra} data-id="element-92" />
        </div>

        <p className="text-center text-gray-300 text-lg md:text-xl max-w-3xl mx-auto mb-10" data-id="element-93">
          El sistema definitivo de tácticas, ejercicios y estrategias diseñado
          exclusivamente para jugadores de pádel.
        </p>

        <div className="flex justify-center" data-id="element-94">
          <button onClick={scrollToCompra} className="bg-[#C6FF3C] hover:bg-[#A4E635] text-black font-bold text-lg md:text-xl px-8 md:px-12 py-4 md:py-5 rounded-lg uppercase tracking-wide transition-all duration-300 flex items-center gap-3 shadow-lg shadow-[#C6FF3C]/20 hover:shadow-xl hover:shadow-[#C6FF3C]/30" data-id="element-95">
            Quiero Dominar la Cancha
            <ChevronRight className="w-6 h-6" data-id="element-96" />
          </button>
        </div>
      </div>
    </section>;
}